import errorMapper from '@/shared/utils/error-mapper';
import modalEventsMixin from './modal-events-mixin';

export default {
  mixins: [
    modalEventsMixin,
  ],
  data() {
    return {
      errors: {},
      error: false,
      active: true,
      saving: false,
      success: false,
    };
  },
  computed: {
    saveButtonLabel() {
      return this.saving ? this.$t('subscriber.processing') : this.$t('common.save');
    },
    removeButtonLabel() {
      return this.saving ? this.$t('subscriber.processing') : this.$t('common.remove');
    },
    saveButtonClass() {
      return this.saving ? 'o-button--disabled' : 'o-button--text';
    },
  },
  watch: {
    $route() {
      this.onRouteChange();
    },
  },
  created() {
    this.$nextTick(() => {
      this.$refs.modal.$on('hide', () => {
        this.setClickedButtonName('');
        this.hide();
      });
    });
  },
  methods: {
    show() {
      this.emitStatsShowModalEvent();
      this.$refs.modal.show();
    },
    hide() {
      this.emitStatsDestroyModalEvent();
      this.$emit('destroy');
    },
    onRouteChange() {
      this.hide();
    },
    wrap(callback) {
      this.$set(this, 'errors', {});
      this.saving = true;

      return callback().then(() => {
        this.active = false;
        this.error = false;
        this.saving = false;
        this.success = true;
      }).catch((e) => {
        this.error = true;
        return errorMapper(this, e).then((errors) => {
          this.saving = false;
          this.$set(this, 'errors', errors);
        });
      });
    },
    updateModalName(name) {
      this.emitStatsDestroyModalEvent();
      this.modalName = name;
      this.emitStatsShowModalEvent();
    },
  },
};
